<c-container fluid class="p-4">
  <c-row>
    <c-col xs="12">
      <c-card class="border-0">
        <c-card-body class="p-0">
          <!-- Messages -->
          @if (error(); as err) {
            <c-alert color="danger" [dismissible]="true" (visibleChange)="clearMessages()">
              {{ err }}
            </c-alert>
          }

          <!-- Filters. No type filter here: mnlo's statement is pool movements only
               (see Api::BookingsController), so "all types" and "transactions" would
               always return the same list and "orders" an empty one. -->
          <c-row class="mb-3 justify-content-start align-items-end">
            <c-col md="2" class="mb-4 mb-md-0">
              <label cLabel for="selectPageCount" class="mb-1">{{ 'bookings.filter.per_page' | translate }}</label>
              <select
                id="selectPageCount"
                cSelect
                [ngModel]="filters().per_page"
                (ngModelChange)="updateFilterProperty('per_page', +$event)"
              >
                @for (option of perPageOptions; track option) {
                  <option [value]="option">{{ option }}</option>
                }
              </select>
            </c-col>

            <c-col md="auto" class="mb-2 mb-md-0">
              <button cButton color="secondary" (click)="resetFilters()" class="w-100 w-md-0">
                {{ 'bookings.filter.reset' | translate }}
              </button>
            </c-col>
            <c-col md="auto" class="mb-2 mb-md-0 ms-md-auto">
              <button cButton color="primary" (click)="exportToExcel()" [disabled]="exporting()" class="w-100 w-md-0">
                <span *ngIf="exporting()" class="spinner-border spinner-border-sm me-1" role="status"></span>
                {{ 'bookings.export.button' | translate }}
              </button>
            </c-col>
          </c-row>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>

  <c-row class="mt-1">
    <c-col xs="12">
      <c-card>
        <c-card-body>
          <!-- Loading -->
          @if (loading()) {
            <div class="text-center py-4">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          }

          <!-- Table -->
          @if (!loading()) {
            @if (bookings().length > 0) {
              <div class="table-responsive">
                <table cTable [hover]="true" [striped]="true">
                  <thead>
                    <tr>
                      <th>{{ 'bookings.table.date' | translate }}</th>
                      <th>{{ 'bookings.table.category' | translate }}</th>
                      <th>{{ 'bookings.table.subject' | translate }}</th>
                      <th>{{ 'bookings.table.from' | translate }}</th>
                      <th>{{ 'bookings.table.to' | translate }}</th>
                      <th class="text-end">{{ 'bookings.table.amount' | translate }}</th>
                      <th>{{ 'bookings.table.notes' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (booking of bookings(); track booking.id) {
                      <tr>
                        <td class="text-nowrap">{{ formatDate(booking.created_at) }}</td>
                        <td>
                          <c-badge [color]="getCategoryBadgeClass(booking.category)">
                            {{ getCategoryLabel(booking.category) | translate }}
                          </c-badge>
                        </td>
                        <td>
                          @if (booking.booking_type === 'order' && booking.order_id) {
                            <span class="text-primary" style="cursor: pointer;" (click)="navigateToOrder(booking.order_id)">
                              {{ booking.subject }}
                            </span>
                          } @else {
                            @if (getSubjectLabel(booking.subject); as label) {
                              {{ label | translate }}
                            } @else {
                              {{ booking.subject }}
                            }
                          }
                        </td>
                        <td class="text-muted">{{ booking.sender_display }}</td>
                        <td class="text-muted">{{ booking.recipient_display }}</td>
                        <td class="text-end text-nowrap" [ngClass]="getAmountClass(booking.amount_display)">
                          <strong>{{ booking.amount_display }} USD</strong>
                        </td>
                        <td class="text-muted small" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" [title]="booking.notes">
                          {{ booking.notes || '-' }}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else {
              <div class="text-center py-4">
                <p class="text-muted mb-0">{{ 'bookings.empty' | translate }}</p>
              </div>
            }

            <!-- Pagination -->
            @if (totalPages() > 1) {
              <div class="mt-3 d-flex justify-content-between align-items-center">
                <c-pagination aria-label="Bookings pagination" class="mb-0">
                  <li cPageItem [disabled]="filters().page === 1" (click)="changePage(1)">
                    <a cPageLink>{{ 'bookings.pagination.first' | translate }}</a>
                  </li>
                  <li cPageItem [disabled]="filters().page === 1" (click)="changePage((filters().page ?? 1) - 1)">
                    <a cPageLink>{{ 'bookings.pagination.prev' | translate }}</a>
                  </li>
                  @for (page of visiblePages(); track page) {
                    <li cPageItem [active]="page === filters().page" (click)="changePage(page)">
                      <a cPageLink>{{ page }}</a>
                    </li>
                  }
                  <li cPageItem [disabled]="filters().page === totalPages()" (click)="changePage((filters().page ?? 1) + 1)">
                    <a cPageLink>{{ 'bookings.pagination.next' | translate }}</a>
                  </li>
                  <li cPageItem [disabled]="filters().page === totalPages()" (click)="changePage(totalPages())">
                    <a cPageLink>{{ 'bookings.pagination.last' | translate }}</a>
                  </li>
                </c-pagination>

                <span class="text-muted">
                  {{ showingStart() }} - {{ showingEnd() }} {{ 'bookings.pagination.of' | translate }} {{ totalCount() }}
                </span>
              </div>
            }
          }
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</c-container>